export default {"src":"/_next/static/media/BN.2b732d8e.svg","height":18,"width":18};